// extracted by mini-css-extract-plugin
module.exports = {"mainLayoutHeader":"mainLayoutHeader--2DyRY","content":"content--1t7h_"};